import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed, watch } from 'vue';
import { BetSlipState } from '@/interface/enum';
import { useRootStore } from '@/stores/rootStore';

export function useDeferredAcceptAnyOddsBanner(betSlipState: Ref<BetSlipState>) {
    const rootStore = useRootStore();
    const { setShowAcceptAnyOddsBanner } = rootStore;
    const { failedPlaceBetShowAaoBanner } = storeToRefs(rootStore);

    const isAnyBetSlipOnScreen = computed(() => (
        betSlipState.value !== BetSlipState.Closed
        && betSlipState.value !== BetSlipState.Mini
    ));

    watch(isAnyBetSlipOnScreen, (isOnScreen) => {
        if (isOnScreen) {
            return;
        }
        if (failedPlaceBetShowAaoBanner.value) {
            setShowAcceptAnyOddsBanner(true);
        }
    });
}
